<script>
	import { familySize } from "../store";
</script>

<div>
	<label class="psl-label" for="family-size">Talouden koko:</label>
	<select class="psl-select" name="family-size" id="family-size" bind:value={$familySize}>
		<option value="single">Yksin asuva</option>
		<option value="couple">Pariskunta</option>
	</select>
</div>

<style>
	div {
		display: flex;
		flex-direction: column;
		width: 100%;
	}
</style>
